import React, { useContext, useState, useEffect } from "react";
import { GlobalAppContext } from "./../../context";
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";
import "mdbootstrap/css/mdb.css";
import Tooltip from "@material-ui/core/Tooltip";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import SpringModal from "../components/springModal";
import IconButton from "@material-ui/core/IconButton";
import NotificationsIcon from "@material-ui/icons/Notifications";
import InvertColorsIcon from "@material-ui/icons/InvertColors";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import Badge from "@material-ui/core/Badge";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import { BrowserRouter as Router, Link, useHistory } from "react-router-dom";
import firebase from "../../services/firebase";
import auth from "../../services/authService";

let navbarClass = (toggled) => {
  return toggled ? "pl-3 pr-0 " : "pl-4 pr-0 ";
};

function Navbar() {
  const {
    toggled,
    theme,
    setTheme,
    user,
    modalOpen,
    setModalOpen,
  } = useContext(GlobalAppContext);

  const [offsetTop, setOffsetTop] = useState(0);

  let history = useHistory();

  useEffect(() => {
    window.addEventListener("scroll", () => setOffsetTop(window.scrollY));
  }, [offsetTop]);

  let themeOption = [
    { theme: "light-theme", label: "Light" },
    { theme: "ice-theme", label: "Ice" },
    { theme: "cool-theme", label: "Cool" },
    { theme: "legacy-theme", label: "Legacy" },
    { theme: "chiller-theme", label: "Chiller" },
    { theme: "default-theme", label: "Dark" },
  ];

  let style =
    offsetTop < 50 && offsetTop > 150
      ? {
          opacity: 0 + offsetTop / 350,
        }
      : offsetTop < 150
      ? {
          opacity: 0 + offsetTop / 150,
        }
      : { boxShadow: "0px 2px 10px 0px rgba(0,0,0,.6)" };

  const handleOpen = () => {
    if (!user) setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  async function logout() {
    await firebase.logout();
    auth.logout();
    window.location = "/";
  }
  return (
    <React.Fragment>
      <MDBNavbar
        // style={style}
        fixed="top"
        scrolling
        scrollingNavbarOffset={100}
        transparent
        dark
        expand="sm"
        className={navbarClass(toggled)}
      >
        <Tooltip title="Beta Version: 0.1.0" arrow placement="bottom">
          <Badge color="primary" className="navbar-badge" badgeContent="beta">
            <MDBNavbarBrand onClick={() => history.push("/")}>
              <strong className="pl-2" style={{ cursor: "pointer" }}>
                INSPIRE
              </strong>
            </MDBNavbarBrand>
          </Badge>
        </Tooltip>

        <MDBNavbarNav right className="inline-block">
          <MDBNavItem>
            <MDBDropdown size="sm p-0">
              <MDBDropdownToggle nav className="navIcon px-0">
                <Tooltip title="Website Theme" arrow placement="top">
                  <IconButton
                    aria-label="delete"
                    className="waves-effect waves-light navIcon"
                  >
                    <InvertColorsIcon fontSize="small" className="icon" />
                  </IconButton>
                </Tooltip>
              </MDBDropdownToggle>

              <MDBDropdownMenu className="dropdown-default dropdown-nav">
                {themeOption.map((theme) => (
                  <MDBDropdownItem
                    key={theme.label}
                    onClick={() => setTheme(theme.theme)}
                  >
                    {theme.label}
                  </MDBDropdownItem>
                ))}
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavItem>
          <MDBNavItem>
            <MDBDropdown>
              <MDBDropdownToggle nav className="navIcon px-0">
                <Badge
                  color="secondary"
                  className="notification-badge"
                  badgeContent="0"
                  showZero
                >
                  <IconButton
                    aria-label="delete"
                    className="waves-effect waves-light iconBtn"
                  >
                    <NotificationsIcon fontSize="small" className="icon" />
                  </IconButton>
                </Badge>

                <div className="d-none d-sm-inline iconText">
                  {" "}
                  Notification{" "}
                  <i className="fa fa-caret-down" aria-hidden="true"></i>
                </div>
              </MDBDropdownToggle>
              <MDBDropdownMenu className="dropdown-default dropdown-nav">
                <MDBDropdownItem>Action</MDBDropdownItem>
                <MDBDropdownItem>Another Action</MDBDropdownItem>
                <MDBDropdownItem>Something else here</MDBDropdownItem>
                <MDBDropdownItem>Something else here</MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavItem>

          <MDBNavItem>
            <MDBDropdown>
              <MDBDropdownToggle
                nav
                className="navIcon px-1"
                onClick={() =>
                  theme === "light-theme"
                    ? setTheme("default-theme")
                    : setTheme("light-theme")
                }
              >
                <Tooltip title="Toggle light/dark theme" arrow placement="top">
                  <IconButton
                    aria-label="delete"
                    className="waves-effect waves-light navIcon"
                  >
                    {theme === "light-theme" ? (
                      <Brightness4Icon fontSize="small" className="icon" />
                    ) : (
                      <Brightness7Icon fontSize="small" className="icon" />
                    )}
                  </IconButton>
                </Tooltip>
              </MDBDropdownToggle>
            </MDBDropdown>
          </MDBNavItem>
          <MDBNavItem>
            <MDBDropdown>
              <MDBDropdownToggle nav className=" navIcon" onClick={handleOpen}>
                {user ? (
                  <Avatar
                    className="mt-1"
                    style={{ width: 35, height: 35 }}
                    alt={user.displayName}
                    src={user.photoURL}
                  />
                ) : (
                  <>
                    <div
                      className="iconText"
                      onClick={() => history.push("/login")}
                    >
                      <IconButton
                        aria-label="delete"
                        className="waves-effect waves-light navIcon"
                      >
                        <AccountCircleIcon fontSize="small" className="icon" />
                      </IconButton>
                      <div className="d-none d-sm-inline iconText p-2">
                        Sign In
                      </div>
                    </div>
                  </>
                )}
              </MDBDropdownToggle>
              {/* {!user && (
                // <SpringModal
                //   open={modalOpen}
                //   handleOpen={handleOpen}
                //   handleClose={handleClose}
                // ></SpringModal>
               
              )} */}
              {user && (
                <MDBDropdownMenu
                  className="dropdown-default dropdown-nav"
                  style={{ width: 325 }}
                >
                  <div className="d-flex">
                    <div
                      className="pic mt-3 mx-3"
                      style={{
                        width: 70,
                        height: 70,
                        overflow: "hidden",
                        borderRadius: "50%",
                        display: "flex",
                        position: "relative",
                      }}
                    >
                      <img
                        style={{
                          width: "inherit",
                          height: "inherit",
                          objectFit: "cover",
                        }}
                        alt={user.displayName}
                        src={user.photoURL}
                      />
                    </div>
                    <div className="content mt-3">
                      <div className="">
                        <strong>{user.displayName}</strong>
                      </div>
                      <div>
                        <p className="pb-0 mb-2" style={{ fontSize: "small" }}>
                          {user.email || user.phoneNumber}
                        </p>
                      </div>
                      <div>
                        <Button
                          size="small"
                          className="mb-2 dropdown-item border-0"
                          variant="outlined"
                        >
                          <Link
                            to="/profile"
                            style={{
                              padding: 0,
                              fontSize: "inherit",
                              fontWeight: "inherit",
                            }}
                          >
                            My Profile
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </div>
                  <MDBDropdownItem divider />
                  <div className="d-block text-center">
                    <Button size="small" className="my-2" variant="contained">
                      <Link
                        to="/"
                        style={{
                          padding: 0,
                          fontSize: "inherit",
                          fontWeight: "inherit",
                        }}
                        className="text-dark mx-2"
                        onClick={logout}
                      >
                        Sign out
                      </Link>
                    </Button>
                  </div>
                  <MDBDropdownItem divider />
                  <div className="d-block text-center">
                    <Button size="small">
                      <Link
                        to="/profile"
                        style={{
                          padding: 0,
                          fontSize: 10,
                          fontWeight: "inherit",
                        }}
                        className="text-muted"
                      >
                        Privacy Policy
                      </Link>
                    </Button>
                    .
                    <Button size="small">
                      <Link
                        to="/profile"
                        style={{
                          padding: 0,
                          fontSize: 10,
                          fontWeight: "inherit",
                        }}
                        className="text-muted"
                      >
                        Terms of Service
                      </Link>
                    </Button>
                  </div>
                </MDBDropdownMenu>
              )}
            </MDBDropdown>
          </MDBNavItem>
        </MDBNavbarNav>
      </MDBNavbar>
    </React.Fragment>
  );
}

export default Navbar;
